import {initElements} from "../define/shared"

export default function initHeader() {
    initElements(".siteHeader", header => {
        const menuBtn = header.querySelector('.siteHeader-menuBtn'),
            menu = header.querySelector('.siteHeader-menu')

        menuBtn.addEventListener('click', ()=>{
            menuBtn.classList.toggle('is-active')
            menu.classList.toggle('is--open')
            header.classList.toggle('menu-is--open')
        })

        window.addEventListener('scroll', () => {
            window.pageYOffset > 0 ? header.classList.add('onscroll') : header.classList.remove('onscroll')
        })
    })
}
